import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pageSlice: "",
};

const pageSlice = createSlice({
  name: "pageSlice",
  initialState,
  reducers: {
    setPageSlice: (state, action) => {
      state.pageSlice = action.payload;
    },
  },
});

export const { setPageSlice } = pageSlice.actions;
export default pageSlice.reducer;
